import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useMainStore from '../store/mainState';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, setIsSignInOpen } = useMainStore();
  const location = useLocation();
  const userId = localStorage.getItem("userId");
  const authToken = localStorage.getItem("authToken");

  // Check if user is authenticated
  const isAuthenticated = !!(user || (userId && authToken));

  useEffect(() => {
    // If not authenticated, open sign-in modal
    if (!isAuthenticated) {
      setIsSignInOpen(true);
    }
  }, [isAuthenticated, setIsSignInOpen]);

  // Redirect to home if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Render children if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;
